const CENT = 100

export const getPercentage = (value: number, total: number): number => {
  if (value < 0) return 0

  return (value / total) * CENT
}
